export const validationRegisterData = {
  type: 'object',
  properties: {
    fio:            { type: ['string'] },    
    email:          { type: "string", format: "email", maxLength: 64 },
    phone:          { type: ['number'] },
    cnt_name:       { type: ['string', 'number']},
    inn:            { type: ['number', 'string'], maxLength: 12 },
    region_code:    { type: ['number'] }
  },
  required: ['cnt_name', 'inn', 'region_code', 'fio', 'email', 'phone'],
};